import { useEffect, useState } from 'react'
import { X, Upload } from 'lucide-react'
import { HeroItem, RedirectType } from 'interfaces/widget-types'
import SearchableCategoryDropdown from './SearchableDropdown'
import SingleSelect from './SingleSelect'

/* ---------- Types ---------- */

interface RedirectOption {
    value: RedirectType
    label: string
}

/**
 * 🔑 THIS IS WHERE YOUR FormData INTERFACE GOES
 */
interface FormData {
    image?: string
    thumbnail?: string
    imageFile?: File | null
    imagePreview?: string | null
    redirectTo?: RedirectType
    redirectionId?: string
}

interface FormErrors {
    image?: string
    redirectionId?: string
}

interface AddItemModalProps {
    isOpen: boolean
    onClose: () => void
    onAdd: (data: Omit<HeroItem, 'id'>) => void
    selectedWidget: string
    redirectOptions: RedirectOption[]
    category?: any
    setCategory?: any
    collection?: any
    selected?: any
    setSelected?: any
}

/* ---------- Helpers ---------- */

const createInitialForm = (redirectOptions: RedirectOption[]): FormData => ({
    image: '',
    imageFile: null,
    imagePreview: null,
    redirectTo: redirectOptions?.[0]?.value ?? 'Episode',
    redirectionId: '',
})

/* ---------- Component ---------- */

const AddItemModal = ({
    isOpen,
    onClose,
    onAdd,
    selectedWidget,
    redirectOptions,
    category,
    setCategory,
    collection,
    setSelected,
    selected,
}: AddItemModalProps) => {
    const [formData, setFormData] = useState<FormData>(
        createInitialForm(redirectOptions)
    )
    const [options, setOptions] = useState<any>([])
    const [errors, setErrors] = useState<FormErrors>({})
    /* Cleanup image preview */
    useEffect(() => {
        if (collection?.length) {
            const options = collection.map((item: any) => {
                return {
                    label: item?.collection?.name,
                    value: item?.collection?.id,
                    thumbnail: item?.collection?.thumbnail || '',
                    icon: item?.collection?.icon || '',
                    cardImage1: item?.collection?.cardImage1 || '',
                    cardImage2: item?.collection?.cardImage2 || '',
                    shortDescription: item?.collection?.shortDescription || '',
                }
            })
            setOptions(options)
        } else {
            setOptions([])
            setSelected('')
        }
    }, [collection])

    const validateForm = (): boolean => {
        const newErrors: FormErrors = {}

        if (!formData.thumbnail) newErrors.image = 'Image is required'
        if (!formData.redirectionId)
            newErrors.redirectionId = 'Redirection ID is required'

        setErrors(newErrors)
        return Object.keys(newErrors).length === 0
    }

    const handleAdd = () => {
        //if (!validateForm()) return
        if (!selected) return

        const selectedCollection = options.find(
            (option) => option.value === selected
        )
        if (!selectedCollection) {
            console.log('No matching option found')
        }

        onAdd({
            thumbnail: selectedCollection?.cardImage1 || selectedCollection?.thumbnail,
            redirectionTo: 'COLLECTION',
            redirectionId: selectedCollection?.value,
            name: selectedCollection?.label || '',
            icon: selectedCollection?.icon || '',
            cardImageFirst: selectedCollection?.cardImage1 || '',
            cardImageSecond: selectedCollection?.cardImage2 || '',
            shortDescription: selectedCollection?.shortDescription || '',
        } as any)

        handleClose()
    }

    const handleClose = () => {
        setFormData(createInitialForm(redirectOptions))
        setErrors({})
        onClose()
        setSelected('')
        setCategory('')
    }

    if (!isOpen) return null

    return (
        <div onPointerDown={(e) => e.stopPropagation()}
  onMouseDown={(e) => e.stopPropagation()}
  onClick={(e) => e.stopPropagation()} className="fixed inset-0 z-50 flex items-center justify-center bg-black/60 backdrop-blur-sm !mt-0">
            <div className="w-96 rounded-xl bg-white dark:bg-slate-900 p-6 shadow-2xl border border-slate-200 dark:border-slate-700">
                {/* Header */}
                <div className="mb-5 flex items-center justify-between">
                    <h3 className="text-lg font-semibold text-slate-800 dark:text-slate-100">
                        Add Item to {selectedWidget}
                    </h3>
                    <button
                        onClick={handleClose}
                        className="rounded-full p-1 text-slate-500 hover:bg-slate-100 hover:text-slate-700 dark:hover:bg-slate-800 dark:hover:text-slate-200 transition"
                    >
                        <X size={18} />
                    </button>
                </div>

                {/* Form Content */}
                <div className="space-y-4">
                    <div className="">
                        <SearchableCategoryDropdown
                            value={category}
                            onSelect={setCategory}
                        />
                    </div>

                    <div className="">
                        <SingleSelect
                            value={selected}
                            options={options}
                            onChange={(value) => {
                                setSelected(value)
                            }}
                        />
                    </div>
                </div>

                {/* Actions */}
                <div className="mt-6 flex gap-3">
                    <button
                        onClick={handleAdd}
                        className="flex-1 rounded-lg bg-blue-600 py-2 text-sm font-medium text-white hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 dark:focus:ring-offset-slate-900 transition"
                    >
                        Add
                    </button>

                    <button
                        onClick={handleClose}
                        className="flex-1 rounded-lg bg-slate-200 py-2 text-sm font-medium text-slate-700 hover:bg-slate-300 focus:outline-none focus:ring-2 focus:ring-slate-400 focus:ring-offset-2 dark:bg-slate-700 dark:text-slate-200 dark:hover:bg-slate-600 dark:focus:ring-offset-slate-900 transition"
                    >
                        Cancel
                    </button>
                </div>
            </div>
        </div>
    )
}

export default AddItemModal
